exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".activity-mastery-container---2j8Oc {\n  height: inherit;\n  text-align: left; }\n  .activity-mastery-container---2j8Oc .activity-mastery---1hmcy {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    height: inherit;\n    min-height: 35px; }\n  .activity-mastery-container---2j8Oc .icon---25BED {\n    width: 16px;\n    height: 20px; }\n  .activity-mastery-container---2j8Oc .icon---25BED svg path {\n      fill: #ffc90d !important; }\n  .activity-mastery-container---2j8Oc .mastered---xlho6 {\n    background: #37c97c;\n    padding-left: 3px;\n    padding-right: 3px; }\n  .activity-mastery-container---2j8Oc .mastered---xlho6 .gold-bars---3rx-w {\n      color: #fff;\n      font-size: 13px;\n      line-height: 13px;\n      font-weight: 500; }\n  .activity-mastery-container---2j8Oc .score-band---2urQq {\n    min-width: 5px; }\n  .activity-mastery-container---2j8Oc .score-band---2urQq.consolidating---2anfU {\n      background: #81daab; }\n  .activity-mastery-container---2j8Oc .score-band---2urQq.developing---29Z6S {\n      background: #f69e13; }\n  .activity-mastery-container---2j8Oc .score-band---2urQq.emerging---3J7Ty {\n      background: #e06d3f; }\n  .activity-mastery-container---2j8Oc .score-band---2urQq.needsImproving---SNOIa {\n      background: #c53902; }\n", ""]);

// exports
exports.locals = {
	"activity-mastery-container": "activity-mastery-container---2j8Oc",
	"activity-mastery": "activity-mastery---1hmcy",
	"icon": "icon---25BED",
	"mastered": "mastered---xlho6",
	"gold-bars": "gold-bars---3rx-w",
	"score-band": "score-band---2urQq",
	"consolidating": "consolidating---2anfU",
	"developing": "developing---29Z6S",
	"emerging": "emerging---3J7Ty",
	"needsImproving": "needsImproving---SNOIa"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./components/activity-status-bar/activity-status-bar.scss
// module id = ffxo
// module chunks = 1